// extracted by mini-css-extract-plugin
export default {"icon":"HamburgerButton_icon__GuIiA"};